import { UseFormReset, UseFormReturn } from "react-hook-form";
import useAppSnackbar, { IAppSnackbar } from "./store";
import { SnackbarCloseReason } from "@mui/material";

export class AppSnackBarHandlers {
  store: IAppSnackbar;
  constructor() {
    this.store = useAppSnackbar.getState();
  }

  handlePopIn = (title: string | undefined, body: string | undefined, showIcon = true) => {
    this.store.setOpen(true);
    this.store.setTitle(title);
    this.store.setBody(body);
    this.store.setShowIcon(showIcon);
  };

  handlePopOut = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") {
      return;
    }

    this.store.setOpen(false);
    this.store.setTitle(undefined);
    this.store.setBody(undefined);
  };
}
